import React, { useState, useEffect } from "react";
import { Table, ProgressBar } from "react-bootstrap";
import { fidelizacao_serie_rede } from "../../services/api";
import { ConverteSerie } from "./modulo";
import './detalhamento_bolsa.css';

const Fidelizacao_serie_rede = (props) => {
    const [data2, setData2] = useState([]);

    let data_inicio = props.di;
    let data_fim = props.df;

    const fetchData = async () => {
        try {
            const response = await fidelizacao_serie_rede(data_inicio, data_fim);
            setData2(response || []);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [data_inicio, data_fim]);

    // Função para replicar a formatação condicional (ColorFormat do Google Charts)
    const getEvasaoStyle = (value) => {
        if (value >= 0 && value < 25) return { backgroundColor: "green", color: "white" };
        if (value >= 25 && value < 40) return { backgroundColor: "orange", color: "white" };
        if (value >= 40 && value < 50) return { backgroundColor: "red", color: "white" };
        if (value >= 50 && value < 75) return { backgroundColor: "darkred", color: "white" };
        if (value >= 75 && value <= 100) return { backgroundColor: "black", color: "white" };
        return {};
    };

    // Variáveis para somar o total geral
    let TotalPR = 0; // total de possibilidade de renovação
    let TotalRN = 0; // Total de renovados
    let TotalEV = 0; // Total Evasão

    // Processamento dos dados
    const processedData = data2.map(item => {
        const pr = parseInt(item.pr) || 0;
        const evasao = parseInt(item.evasao) || 0;
        const rn = pr - evasao;
        const rnp = pr > 0 ? 100 - ((evasao * 100) / pr) : 0; // % de renovação
        const evp = pr > 0 ? ((evasao * 100) / pr) : 0; // % de evasão
        const serieNome = ConverteSerie(item.serie) || item.serie;

        TotalPR += pr;
        TotalRN += rn;
        TotalEV += evasao;

        return {
            serieNome,
            pr,
            rn,
            rnp,
            evp
        };
    });

    // Cálculos da linha de Total
    const TotalRNP = TotalPR > 0 ? 100 - ((TotalEV * 100) / TotalPR) : 0;
    const TotalEVP = TotalPR > 0 ? ((TotalEV * 100) / TotalPR) : 0;

    return (
        <div className="media mt-3 Evasao">
            {/* Cabeçalho padronizado */}
            <div className="table-responsive shadow-sm rounded border">
                {/* Classe "small" adicionada para manter a fonte menor, como solicitado anteriormente */}
                <Table hover bordered size="sm" className="text-center align-middle bg-white m-0 small">
                    <thead className="table-dark text-nowrap">
                        <tr>
                            <th className="align-middle text-start ps-3">SÉRIE 2026</th>
                            <th className="align-middle">P. Renovação</th>
                            <th className="align-middle">Renovados</th>
                            <th className="align-middle">RENOVAÇÃO</th>
                            <th className="align-middle">EVASÃO</th>
                        </tr>
                    </thead>
                    <tbody>
                        {processedData.map((row, idx) => (
                            <tr key={idx}>
                                <td className="text-start fw-bold bg-light ps-3">
                                    {row.serieNome}
                                </td>
                                <td>{row.pr}</td>
                                <td>{row.rn}</td>
                                <td>
                                    {/* Exibição da porcentagem e Barra de Progresso */}
                                    <div className="d-flex align-items-center justify-content-center gap-2">
                                        <span style={{ minWidth: '50px' }}>{row.rnp.toFixed(2)}%</span>
                                        <ProgressBar
                                            now={row.rnp}
                                            style={{ width: '60px', height: '8px' }}
                                            variant="primary"
                                        />
                                    </div>
                                </td>
                                {/* Aplicação da Formatação Condicional na célula (ColorFormat) */}
                                <td style={{ ...getEvasaoStyle(row.evp), fontWeight: '500' }}>
                                    {row.evp.toFixed(2)}%
                                </td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot className="fw-bolder border-top border-dark">
                        <tr className="bg-light">
                            <td className="text-start ps-3">TOTAL</td>
                            <td>{TotalPR}</td>
                            <td>{TotalRN}</td>
                            <td>
                                <div className="d-flex align-items-center justify-content-center gap-2">
                                    <span style={{ minWidth: '50px' }}>{TotalRNP.toFixed(2)}%</span>
                                    <ProgressBar
                                        now={TotalRNP}
                                        style={{ width: '60px', height: '8px' }}
                                        variant="primary"
                                    />
                                </div>
                            </td>
                            {/* A formatação condicional também se aplica ao total geral */}
                            <td style={getEvasaoStyle(TotalEVP)}>
                                {TotalEVP.toFixed(2)}%
                            </td>
                        </tr>
                    </tfoot>
                </Table>
            </div>
        </div>
    );
};

export default Fidelizacao_serie_rede;